var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNoAccessMarvin(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 671 860",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M564.533 852.006h-100.12c-17.83 0-32.31-14.48-32.31-32.31v-21.02c0-6.23 5.06-11.29 11.29-11.29h121.14c17.83 0 32.31 14.48 32.31 32.31 0 17.83-14.48 32.31-32.31 32.31z",
    fill: "#FD934F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M431.113 787.676l1 32.02c0 17.77 14.54 32.31 32.31 32.31h100.12c17.77 0 32.31-14.54 32.31-32.31",
    stroke: "#FA505E",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M139.963 787.386h121.14c6.23 0 11.29 5.06 11.29 11.29v21.02c0 17.83-14.48 32.31-32.31 32.31h-100.12c-17.83 0-32.31-14.48-32.31-32.31 0-17.83 14.48-32.31 32.31-32.31z",
    fill: "#FD934F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M271.393 787.676l1 32.02c0 17.77-14.54 32.31-32.31 32.31h-100.12c-17.77 0-32.31-14.54-32.31-32.31",
    stroke: "#FA505E",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M581.013 358.026v321.65c0 62.9-48.41 114.51-110 119.58-3.29.28-6.63.42-10 .42h-217.53c-3.37 0-6.71-.14-10-.42-61.6-5.07-110-56.68-110-119.58v-321.65c0-126.34 102.42-228.76 228.76-228.76 63.17 0 120.36 25.6 161.76 67 41.4 41.4 67.01 98.59 67.01 161.76z",
    fill: "#2A848E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.773 632.196c-12.74 16.6-4.97 40.74 15.02 46.95 52.2 16.22 111.23-.63 146.44-46.53 43.94-57.27 34.6-138.65-20.17-184.59L8.773 632.186v.01z",
    fill: "#2A848E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M471.013 684.076v-151.77c0-65.53-52.53-119.69-118.06-120.07-65.81-.39-119.47 53.03-119.47 118.76v153.08c0 41.75 33.85 75.6 75.6 75.6h86.33c41.75 0 75.6-33.85 75.6-75.6z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M469.913 84.636c12.261 12.26 12.261 32.173 0 44.434l-66.065 66.065c-12.261 12.262-32.173 12.262-44.434 0l-22.218-22.217 88.275-88.275c12.262-12.261 32.174-12.261 44.435 0l.007-.007z",
    fill: "#2A848E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M413.387 66.03c12.261 12.262 12.261 32.174 0 44.435l-66.065 66.065c-12.261 12.262-32.174 12.262-44.435 0l-22.217-22.217 88.275-88.275c12.261-12.261 32.173-12.261 44.435 0l.007-.007z",
    fill: "#2A848E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M368.963 66.026c12.22-12.22 32.21-12.22 44.43 0 12.22 12.22 12.22 32.21 0 44.43l-50.92 50.92",
    stroke: "#006C78",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M352.253 547.596c-87.39 0-166.52-25.6-223.79-67-.05-.04-.1-.07-.16-.11-6.18-4.47-14.82-.12-14.82 7.51v218.02c0 33.14 26.86 60 60 60h357.53c33.14 0 60-26.86 60-60v-218.03c0-7.61-8.62-12-14.78-7.54-57.29 41.48-136.48 67.15-223.97 67.15h-.01z",
    fill: "#094C4C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M306.413 673.276c-13.24 9.45-31.62-.02-31.62-16.28v-55.35c0-16.26 18.38-25.73 31.62-16.28l20.53 14.65c20.12 14.36 20.12 44.25 0 58.61l-20.53 14.65zM398.083 673.276c13.24 9.45 31.62-.02 31.62-16.28v-55.34c0-16.26-18.38-25.73-31.62-16.28l-20.53 14.65c-20.12 14.36-20.12 44.25 0 58.61l20.53 14.65v-.01zM300.624 629.326h103.26",
    stroke: "#FA505E",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M360.413 603.166h-16.32c-9.941 0-18 8.059-18 18v16.32c0 9.941 8.059 18 18 18h16.32c9.941 0 18-8.059 18-18v-16.32c0-9.941-8.059-18-18-18z",
    fill: "#094C4C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M360.413 611.166c5.52 0 10 4.48 10 10v16.32c0 5.52-4.48 10-10 10h-16.32c-5.52 0-10-4.48-10-10v-16.32c0-5.52 4.48-10 10-10h16.32zm0-16h-16.32c-14.34 0-26 11.66-26 26v16.32c0 14.34 11.66 26 26 26h16.32c14.34 0 26-11.66 26-26v-16.32c0-14.34-11.66-26-26-26z",
    fill: "#FA505E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M376.953 308.406h-49.41v48.47h49.41v-48.47z",
    fill: "#024447"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M152.093 308.406h180.99v82.98c0 34.77-28.23 63-63 63h-54.99c-34.77 0-63-28.23-63-63v-82.98z",
    fill: "#024447"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M313.083 338.406v52.97c0 23.75-19.25 43-43 43h-54.99c-.73 0-1.46-.02-2.18-.06-11.66-.58-22.12-5.83-29.52-13.92-7.02-7.65-11.3-17.85-11.3-29.02v-52.97c0-5.52 4.48-10 10-10h120.99c5.52 0 10 4.48 10 10z",
    fill: "#006C78"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M313.083 337.326l-45.6 45.6c-9.07 9.07-9.07 23.78 0 32.85 4.54 4.54 10.48 6.8 16.43 6.8 5.95 0 11.89-2.27 16.43-6.8l9.82-9.82a9.99 9.99 0 002.93-7.07v-61.56h-.01z",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M313.083 326.816h-43.47l-68.67 68.67c-7.45 7.45-7.45 19.53 0 26.99 3.73 3.73 8.61 5.59 13.49 5.59 4.88 0 9.77-1.86 13.49-5.59l85.15-85.15v-10.51h.01zM211.183 326.816l-20.41 20.41c-3.27 3.27-3.27 8.58 0 11.85a8.351 8.351 0 005.93 2.46c2.15 0 4.29-.82 5.93-2.46l32.26-32.26h-23.71z",
    fill: "#024447"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M250.893 344.546l-43.42 43.42",
    stroke: "#fff",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M152.093 308.406h-49.41v48.47h49.41v-48.47z",
    fill: "#024447"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M102.683 356.866v-48.47l-28.38 46.17c-1.23 2-1.88 4.3-1.88 6.65 0 12.8 16.8 17.55 23.5 6.65l6.76-11zM489.413 454.376h-54.99c-34.77 0-63-28.23-63-63v-82.98h180.99v82.98c0 34.77-28.23 63-63 63z",
    fill: "#024447"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M532.413 338.406v52.97c0 23.75-19.25 43-43 43h-54.99c-.73 0-1.46-.02-2.18-.06-11.66-.58-22.12-5.83-29.52-13.92-7.02-7.65-11.3-17.85-11.3-29.02v-52.97c0-5.52 4.48-10 10-10h120.99c5.52 0 10 4.48 10 10z",
    fill: "#006C78"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M532.413 337.326l-45.6 45.6c-9.07 9.07-9.07 23.78 0 32.85 4.54 4.54 10.48 6.8 16.43 6.8 5.95 0 11.89-2.27 16.43-6.8l9.82-9.82a9.99 9.99 0 002.93-7.07v-61.56h-.01z",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M532.414 326.816h-43.47l-68.67 68.67c-7.45 7.45-7.45 19.53 0 26.99 3.73 3.73 8.61 5.59 13.49 5.59 4.88 0 9.77-1.86 13.49-5.59l85.15-85.15v-10.51h.01zM430.513 326.816l-20.41 20.41c-3.27 3.27-3.27 8.58 0 11.85a8.351 8.351 0 005.93 2.46c2.15 0 4.29-.82 5.93-2.46l32.26-32.26h-23.71z",
    fill: "#024447"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M470.223 344.546l-43.42 43.42",
    stroke: "#fff",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M601.823 308.406h-49.41v48.47h49.41v-48.47z",
    fill: "#024447"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M601.813 356.866v-48.47l28.38 46.17c1.23 2 1.88 4.3 1.88 6.65 0 12.8-16.8 17.55-23.5 6.65l-6.76-11z",
    fill: "#024447"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M295.153 430.066h65.34c15.81 0 28.64 12.83 28.64 28.64s-12.83 28.64-28.64 28.64h-36.7c-15.81 0-28.64-12.83-28.64-28.64v-28.64z",
    fill: "#FD934F"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M320.813 401.296h62.88c14.16 0 25.66 11.5 25.66 25.66s-11.5 25.66-25.66 25.66h-88.54v-25.66c0-14.16 11.5-25.66 25.66-25.66z",
    fill: "#FED425"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M231.943 282.916h72.85",
    stroke: "#006C78",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M550.903 387.346c-61.64 0-111.61 65.99-111.61 147.39 0 2.08.04 4.15.11 6.21l-25.63-12.99c-19.52-9.89-43.58-2.02-53.47 17.5s-2.18 41.83 17.5 53.47c19.67 11.64 80.52 47.63 80.52 47.63a181.863 181.863 0 0092.58 25.33c41.18 0 78.73-23.93 95.77-61.42 10.06-22.13 15.84-48.04 15.84-75.73 0-81.4-49.97-147.39-111.61-147.39z",
    fill: "#2A848E"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M550.903 387.346c-61.64 0-111.61 65.99-111.61 147.39 0 2.08.04 4.15.11 6.21l-25.63-12.99c-19.52-9.89-43.58-2.02-53.47 17.5s-2.18 41.83 17.5 53.47c19.67 11.64 80.52 47.63 80.52 47.63a181.863 181.863 0 0092.58 25.33c41.18 0 78.73-23.93 95.77-61.42 10.06-22.13 15.84-48.04 15.84-75.73 0-81.4-49.97-147.39-111.61-147.39z",
    stroke: "#006C78",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M413.773 527.956l80.37 40.74a73.258 73.258 0 0136.27 41.86M519.873 395.416v116.99M581.923 395.416v116.99M496.773 523.296c13.85-4.59 32.99-7.43 54.13-7.43s40.27 2.84 54.13 7.43",
    stroke: "#006C78",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M550.394 252.906c10.09 0 18.27-8.17 18.27-18.26.02-59.76-24.18-113.87-63.33-153.05-39.29-39.32-93.63-63.59-153.64-63.44-119.53.3-215.8 98.39-215.85 217.92v16.66l414.55.16v.01z",
    fill: "#094C4C"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M277.463 81.566c19.15-39.17 45.62-63.4 74.87-63.41 54.84-.02 99.98 85.12 105.45 194.24M352.333 18.146c94.85-.04 175.471 60.95 204.731 145.86",
    stroke: "#024447",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M338.601 31.02l40.89-.015c8.56-.003 15.497-6.945 15.494-15.505C394.982 6.94 388.04.002 379.48.005L338.59.02c-8.561.003-15.498 6.945-15.495 15.505.003 8.56 6.945 15.498 15.506 15.495zM405.764 95.356a9.46 9.46 0 10-18.92.001 9.46 9.46 0 0018.92 0zM297.664 211.496l-276.54-.05c-11.18 0-20.71 8.69-21.11 19.86-.42 11.73 8.96 21.38 20.6 21.38l318.28.06c0-22.78-18.45-41.25-41.23-41.26v.01z",
    fill: "#024447"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M399.704 282.916c10.37-35.92 53.74-49.99 83.22-27.01",
    stroke: "#006C78",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M25.794 599.436l69.16 70.51c11.849 12.08 31.279 12.13 43.189.11l73.46-74.11-95.43-114.23-90.37 117.71-.01.01z",
    fill: "#094C4C"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M119.724 672.956c19.26-8.82 36.72-22.35 50.51-40.33M232.224 728.236h240.06",
    stroke: "#024447",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAccessMarvin);
export default ForwardRef;